import React, { Component } from "react";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import withAuth from "../../../components/withAuth";

// LIBS
import API from "../../../api";
import { setUser } from "../../../actions/MyUserActions";
import { setToken } from "../../../api/jwt";
import Model from "../../../models/users";
import validateForm from "../../../lib/helpers/validateForm";
import {
  getDateFormat,
  getDateFromDatepicker
} from "../../../lib/helpers/dates";

// UI
import {
  Alerts,
  Header,
  HeaderPage,
  Box,
  Row,
  Col,
  Input,
  Button,
  HR,
  Dropdown
} from "../../../ui";

class SettingsPage extends Component {
  state = {
    titleHeader: "Настройки аккаунта",
    user: {},
    form: {
      f: {
        value: "",
        isEdited: false,
        isDate: false,
        isError: false,
        errors: [],
        validate: Model.f
      },
      i: {
        value: "",
        isEdited: false,
        isDate: false,
        isError: false,
        errors: [],
        validate: Model.i
      },
      o: {
        value: "",
        isEdited: false,
        isDate: false,
        isError: false,
        errors: [],
        validate: Model.o
      },
      email: {
        value: "",
        isEdited: false,
        isDate: false,
        isError: false,
        errors: [],
        validate: Model.email
      },
      iin: {
        value: "",
        isEdited: false,
        isNumber: true,
        isError: false,
        errors: [],
        validate: Model.iin
      },
      docs: {
        value: "",
        isEdited: false,
        isNumber: false,
        isError: false,
        errors: [],
        validate: Model.docs
      },
      docs_number: {
        value: "",
        isEdited: false,
        isNumber: true,
        isError: false,
        errors: [],
        validate: Model.docs_number
      },
      docs_give_from: {
        value: "",
        isEdited: false,
        isNumber: false,
        isError: false,
        errors: [],
        validate: Model.docs_give_from
      },
      docs_give_date: {
        value: "",
        isEdited: false,
        isDate: true,
        isError: false,
        errors: [],
        validate: Model.docs_give_date
      },
      tel: {
        value: "",
        isEdited: false,
        isDate: false,
        isError: false,
        errors: [],
        validate: Model.tel
      },
      address: {
        value: "",
        isEdited: false,
        isDate: false,
        isError: false,
        errors: [],
        validate: Model.address
      }
    },
    formPassword: {
      password: {
        value: "",
        isEdited: false,
        isDate: false,
        isError: false,
        errors: [],
        validate: { ...Model.password, min: 6 }
      },
      passwordNew: {
        value: "",
        isEdited: false,
        isDate: false,
        isError: false,
        errors: [],
        validate: Model.password
      },
      passwordNewRe: {
        value: "",
        isEdited: false,
        isDate: false,
        isError: false,
        errors: [],
        validate: Model.password
      }
    },
    buttons: {
      save: {
        disabled: false
      },
      docs: {
        list: [
          {
            id: "ud",
            title: "Удостоверение личности",
            onSelect: true,
            select: true
          },
          {
            id: "passport",
            title: "Паспорт",
            onSelect: true,
            select: true
          }
        ]
      }
    },
    buttonPassword: false
  };

  async componentDidMount() {
    const user = await API.me.getInfo();

    if (user && user._id) {
      const { form } = this.state;

      // Заполняем форму
      for (let key in form) {
        if (form[key].isNumber) {
          form[key].value = String(user[key] || "") || "";
        } else if (form[key].isDate) {
          let resultDate = getDateFromDatepicker(user[key]);
          form[key].value = user[key]
            ? resultDate.isCorrect
              ? getDateFormat(resultDate.date)
              : user[key]
            : "";
        } else {
          form[key].value = user[key] || "";
        }
      }

      this.setState({ user, form });
    }
  }

  handleInput = e => {
    let value = e.target.value;
    let name = e.target.name;
    const { form } = this.state;

    if (name && form[name]) {
      if (form[name].isNumber) {
        value = String(value || "") || "";
      }

      this.setState(prevState => {
        return {
          form: {
            ...prevState.form,
            [name]: {
              ...prevState.form[name],
              value,
              isEdited: true,
              isError: false,
              errors: []
            }
          }
        };
      });
    }
  };

  handleInputPassword = e => {
    let value = e.target.value;
    let name = e.target.name;
    const { formPassword } = this.state;

    if (name && formPassword[name]) {
      if (formPassword[name].isNumber) {
        value = String(value) || "";
      }

      this.setState(prevState => {
        return {
          formPassword: {
            ...prevState.formPassword,
            [name]: {
              ...prevState.formPassword[name],
              value,
              isEdited: true,
              isError: false,
              errors: []
            }
          }
        };
      });
    }
  };

  handleDatepicker = (name, value) => {
    console.log("handleDatepicker in page:", name, value);

    this.setState(prevState => {
      return {
        form: {
          ...prevState.form,
          [name]: {
            ...prevState.form[name],
            value,
            isEdited: true,
            isError: false,
            errors: []
          }
        }
      };
    });
  };

  handleSelectDropdown(item, name) {
    if (item && name) {
      let value = item.id;

      this.setState(prevState => {
        return {
          form: {
            ...prevState.form,
            [name]: {
              ...prevState.form[name],
              value,
              isEdited: true,
              isError: false,
              errors: []
            }
          }
        };
      });
    }
  }

  handleFormSubmit = async e => {
    e.preventDefault();

    const result = validateForm(this.state.form);

    this.setState({
      form: result.form
    });

    // Success
    if (result.valid) {
      const { save } = this.state.buttons;
      save.disabled = true;

      // Отключаем кнопку
      this.setState(prevState => {
        return {
          buttons: { ...prevState.buttons, save },
          loading: true
        };
      });

      save.disabled = false;

      const { form } = this.state;
      const optionsRequest = {};

      for (let nameItem in form) {
        if (form[nameItem].isEdited) {
          optionsRequest[nameItem] = form[nameItem].value;
        }
      }

      // Есть изменения?
      if (Object.keys(optionsRequest).length) {
        // Изменение текущего
        const resultUpdated = await API.me.update({ ...optionsRequest });

        if (resultUpdated && resultUpdated.user && resultUpdated.token) {
          // Сохраняем пользователя
          const { dispatch } = this.props;

          dispatch(setUser(resultUpdated.user));

          setToken(resultUpdated.token);

          Alerts.success("Информация об аккаунте сохранена");

          // Включаем кнопку, данные сохранились
          this.setState(prevState => {
            return {
              buttons: { ...prevState.buttons, save }
            };
          });

          this.props.history.goBack();
        } else {
          Alerts.error("Аккаунт не изменён");

          // Включаем кнопку, данные не сохранились
          this.setState(prevState => {
            return {
              buttons: { ...prevState.buttons, save }
            };
          });
        }
      } else {
        Alerts.alert("В аккаунте нет изменений");

        // Включаем кнопку, данные не сохранились
        this.setState(prevState => {
          return {
            buttons: { ...prevState.buttons, save }
          };
        });

        this.props.history.goBack();
      }
    }
  };

  handleFormSubmitPassword = async e => {
    e.preventDefault();

    const result = validateForm(this.state.formPassword);

    this.setState({
      formPassword: result.form
    });

    // Success
    if (result.valid) {
      const { formPassword } = this.state;

      if (formPassword.passwordNew.value === formPassword.passwordNewRe.value) {
        let buttonPassword = this.state.buttonPassword;
        buttonPassword = true;

        // Отключаем кнопку
        this.setState({ buttonPassword });

        buttonPassword = false;

        const optionsRequest = {};

        for (let nameItem in formPassword) {
          if (formPassword[nameItem].isEdited) {
            optionsRequest[nameItem] = formPassword[nameItem].value;
          }
        }

        // Есть изменения?
        if (Object.keys(optionsRequest).length) {
          // Изменение текущего
          const resultUpdated = await API.me.changePassword({
            ...optionsRequest
          });

          if (resultUpdated) {
            Alerts.success("Пароль изменён");

            // Включаем кнопку, данные сохранились
            this.setState(prevState => {
              return {
                buttonPassword,
                formPassword: {
                  ...prevState.formPassword,
                  password: {
                    ...prevState.formPassword.password,
                    value: "",
                    isError: false,
                    errors: []
                  },
                  passwordNew: {
                    ...prevState.formPassword.passwordNew,
                    value: "",
                    isError: false,
                    errors: []
                  },
                  passwordNewRe: {
                    ...prevState.formPassword.passwordNewRe,
                    value: "",
                    isError: false,
                    errors: []
                  }
                }
              };
            });
          } else {
            Alerts.error("Пароль не изменён");

            // Включаем кнопку, данные не сохранились
            this.setState(prevState => {
              return {
                buttonPassword,
                formPassword: {
                  ...prevState.formPassword,
                  password: {
                    ...prevState.formPassword.password,
                    isError: true,
                    errors: ["Введите правильный пароль"]
                  }
                }
              };
            });
          }
        } else {
          Alerts.alert("В пароле нет изменений");

          // Включаем кнопку, данные не сохранились
          this.setState({ buttonPassword });
        }
      } else {
        this.setState(prevState => {
          return {
            formPassword: {
              ...prevState.formPassword,
              passwordNew: {
                ...prevState.formPassword.passwordNew,
                isError: true,
                errors: ["Новый пароль и повтор нового пароля должны совпадать"]
              },
              passwordNewRe: {
                ...prevState.formPassword.passwordNewRe,
                isError: true,
                errors: ["Новый пароль и повтор нового пароля должны совпадать"]
              }
            }
          };
        });
      }
    }
  };

  render() {
    const { user } = this.state;

    return (
      <div className="short">
        <Helmet>
          <title>{this.state.titleHeader}</title>
        </Helmet>

        <HeaderPage
          title={this.state.titleHeader}
          back={this.props.history.goBack}
        />

        <Box>
          <Header size={2} margin="no-top">
            {user.username}
          </Header>

          <Row>
            <Col padding="no-top-right-left" lg={8} md={7} sm={12} xs={12}>
              <form className="form" onSubmit={this.handleFormSubmit}>
                <Row>
                  <Col padding="no-top-left">
                    <Header size={5} margin="no-top">
                      Главное
                    </Header>

                    <Input
                      label="Фамилия:"
                      name="f"
                      value={this.state.form.f.value}
                      errors={this.state.form.f.errors}
                      handleChange={this.handleInput}
                    />

                    <Input
                      label="Имя:"
                      name="i"
                      value={this.state.form.i.value}
                      errors={this.state.form.i.errors}
                      handleChange={this.handleInput}
                    />

                    <Input
                      label="Имя:"
                      name="o"
                      value={this.state.form.o.value}
                      errors={this.state.form.o.errors}
                      handleChange={this.handleInput}
                    />

                    <Input
                      label="Email:"
                      name="email"
                      value={this.state.form.email.value}
                      errors={this.state.form.email.errors}
                      handleChange={this.handleInput}
                    />
                  </Col>

                  <Col padding="no-top-left">
                    <Header size={5} margin="no-top">
                      Документ
                    </Header>

                    <Input
                      label="ИИН:"
                      name="iin"
                      // type="integer"
                      value={this.state.form.iin.value}
                      errors={this.state.form.iin.errors}
                      handleChange={this.handleInput}
                    />

                    <Dropdown
                      label="Вид документа:"
                      name="docs"
                      block={true}
                      required={true}
                      type="select"
                      title="Выберите тип документа"
                      errors={this.state.form.docs.errors}
                      list={this.state.buttons.docs.list}
                      selectedId={this.state.form.docs.value}
                      onSelect={item => {
                        this.handleSelectDropdown(item, "docs");
                      }}
                    />

                    <Input
                      label="Номер документа:"
                      name="docs_number"
                      // type="integer"
                      value={this.state.form.docs_number.value}
                      errors={this.state.form.docs_number.errors}
                      handleChange={this.handleInput}
                    />

                    <Input
                      label="Кем выдан:"
                      name="docs_give_from"
                      value={this.state.form.docs_give_from.value}
                      errors={this.state.form.docs_give_from.errors}
                      handleChange={this.handleInput}
                    />

                    <Input
                      label="Дата выдачи:"
                      name="docs_give_date"
                      type="date"
                      dateTop={true}
                      value={this.state.form.docs_give_date.value}
                      errors={this.state.form.docs_give_date.errors}
                      handleChange={this.handleInput}
                      handleChangeDate={this.handleDatepicker}
                    />
                  </Col>

                  <Col padding="no-top-left">
                    <Header size={5} margin="no-top">
                      Прочее
                    </Header>

                    <Input
                      label="Телефон:"
                      name="tel"
                      value={this.state.form.tel.value}
                      errors={this.state.form.tel.errors}
                      handleChange={this.handleInput}
                    />

                    <Input
                      label="Адрес:"
                      name="address"
                      value={this.state.form.address.value}
                      errors={this.state.form.address.errors}
                      handleChange={this.handleInput}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col padding="no-top-left-right">
                    <Button
                      type="submit"
                      theme="success"
                      block={true}
                      disabled={this.state.buttons.save.disabled}
                    >
                      Сохранить информацию
                    </Button>
                  </Col>
                </Row>
              </form>
            </Col>

            <Col padding="no-top" lg={1} md={1} sm="hide" xs="hide">
              <HR
                vertical={true}
                mutted={true}
                theme="dashed"
                margin="left-right-auto"
              />
            </Col>

            <Col padding="no-top-right-left" lg={3} md={4} sm={12} xs={12}>
              <form className="form" onSubmit={this.handleFormSubmitPassword}>
                <Row>
                  <Col padding="no-top-left">
                    <Header size={5} margin="no-top">
                      Пароль
                    </Header>

                    <Input
                      label="Старый пароль:"
                      name="password"
                      type="password"
                      value={this.state.formPassword.password.value}
                      errors={this.state.formPassword.password.errors}
                      handleChange={this.handleInputPassword}
                    />

                    <Input
                      label="Новый пароль пароля:"
                      name="passwordNew"
                      type="password"
                      value={this.state.formPassword.passwordNew.value}
                      errors={this.state.formPassword.passwordNew.errors}
                      handleChange={this.handleInputPassword}
                    />

                    <Input
                      label="Повтор нового пароля:"
                      name="passwordNewRe"
                      type="password"
                      value={this.state.formPassword.passwordNewRe.value}
                      errors={this.state.formPassword.passwordNewRe.errors}
                      handleChange={this.handleInputPassword}
                    />

                    <Button
                      type="submit"
                      theme="primary"
                      block={true}
                      disabled={this.state.buttonPassword}
                    >
                      Изменить пароль
                    </Button>
                  </Col>
                </Row>
              </form>
            </Col>
          </Row>
        </Box>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user
});

export default connect(mapStateToProps)(withAuth(SettingsPage));
